import { action } from 'typesafe-actions';

export const SET_ERROR_MODAL = 'errorModal/SET_ERROR_MODAL';
export const setErrorModal = (msg?: string, onClose?: () => void) => action(SET_ERROR_MODAL, { msg, onClose });
